import {createFileRoute} from "@tanstack/react-router";
import {RouteComponent} from "./-routeComponent";

// Project home (SOW #9, surface 2): identity, authored instructions, members, project memory, and
// the project's chats. The sidebar project folders link here. The loader is minimal — the project
// and its chats are fetched client-side via the shared `useProjects` / chats queries, mirroring the
// adgpt chat route (no server fetch in the loader).
export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_adgptScaffold/adgpt/projects/$projectId",
)({
    loader: ({context, params}) => ({
        projectId: params.projectId,
        workspaceId: context.workspace.id,
        intellsysBaseUrl: context.intellsysBaseUrl,
        accessToken: context.authenticationStatus.accessToken,
    }),
    component: RouteComponent,
});
